import { render, staticRenderFns } from "./AssetLocate.vue?vue&type=template&id=0f3a5d1a&scoped=true&"
import script from "./AssetLocate.vue?vue&type=script&lang=js&"
export * from "./AssetLocate.vue?vue&type=script&lang=js&"
import style0 from "./AssetLocate.vue?vue&type=style&index=0&id=0f3a5d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a5d1a",
  null
  
)

export default component.exports